export default __webpack_public_path__ + "static/ally-management-mobile-banner-9462944d15be91c7f083908f2ed7a242.png";